<template>
    <div class="two-column-inner">
        <div class="row">
            <div class="col-md-8">
                <div class="left-block">
                   
                    <div class="image-block">
                        <img :src="getImageUrl" :alt="fundraiser.name" width="100%"
                             class="fundraiser-thumbnail">
                    </div>
                   
                    <div class="tab-section">
                        <ul class="resp-tabs-list no-print">
                            <li :class="{'resp-tab-active' : !useReponsiveTab }">Story</li>
                            
	                        <li :class="{'resp-tab-disabled' : !useReponsiveTab }">
	                            {{ useReponsiveTab ? '': 'No' }}
                                Updates {{updatesCounts}}
                            </li>
                        </ul>
                        <div class="resp-tabs-container">
                            <div>
                                <div class="title-block">
                                    <h4 class="title-4" :class="{'mt-20' : !useReponsiveTab}">
                                        {{fundraiser.name}} at {{fundraiser.teacher.school}}
                                    </h4>
                                </div>
                                
                                <fundraiser-profile
                                    :user="user"
                                    :teacher-id="fundraiser.teacher_id"
                                    :teacher="fundraiser.teacher"
                                    :story="fundraiser.teacher.personal_statement"
                                    :fundraiser="fundraiser"
                                >
                                </fundraiser-profile>
                            </div>
                            
                            <div v-if="useReponsiveTab">
                                <fundraiser-updates :fundraiser="fundraiser"
                                :updates-init="fundraiser.posts"
                                :user="user"
                                :current-post-route="post"
                                :current-tab="currentTab"
                                :authenticated="authenticated">
                                    <!--<template slot="loginSlot">-->
                                        <!--<login-button></login-button>-->
                                    <!--</template>-->
                                </fundraiser-updates>
                            </div>
                            
                        </div>

                    </div>

                </div>
                <donators-comments v-if="user===null || user.role.slug!=='teacher'" :fundraiser-id="fundraiser.id"
                                   :user="user"></donators-comments>
                <fundraiser-report-question :fundraiser-id="fundraiser.id"></fundraiser-report-question>
            </div>
            <div class="col-md-4 no-print">
                <funding-details :fundraiser="fundraiser"></funding-details>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            imageUrl: {
                required: false,
                default: 'https://via.placeholder.com/750x480'
            },
            fundraiser: {
                type: Object,
                required: true
            },
            postData: {
                type: Object,
                required: false
            },
            authenticated: {
                type: Boolean,
                required: false
            },
            user: {
                type: Object,
                required: false
            }
        },
	    data() {
            return {
                activeName: 'first',
                post: undefined,
                currentTab: null,
            };
        },
	    computed: {
            isTherePost() {
                return (this.post === undefined) ? "0" : "1";
            },
            updatesCounts() { 
                return (this.fundraiser.posts.length > 0) ? '( ' + this.fundraiser.posts.length + ' )' : '';
            },
            getImageUrl() {
                if(this.fundraiser.mainImage === null || this.fundraiser.mainImage === undefined) {
                    let index = Math.floor((Math.random() * 4) + 1);
                    return '/images/content/project.png';
                }
                return this.fundraiser.mainImage;
            },
            useReponsiveTab(){
            	return this.updatesCounts.length || (!!this.user && this.user.role.slug !== 'donor');
            },
        },
	    methods:{
        	loadSpreedlyApi(){
        		let vm = this;
		
				this.$alert('Gateway service not accesible at this moment, please try again.', 'Title', {
					confirmButtonText: 'OK',
					center: true,
					closeOnClickModal:false,
					type: 'warning',
					callback: action => {
						location.reload();
					}
				});
        		/*
        		$.getScript( "https://core.spreedly.com/iframe/express-2.min.js" )
					.done(function( script, textStatus ) {
						console.log(window.SpreedlyExpress);
						vm.registerSpreedlyExpressPyamentListener()
					})
					.fail(function( jqxhr, settings, exception ) {
						console.log(exception)
					});
				*/
	        },
			registerSpreedlyExpressPyamentListener(){
        		let vm = this;
				SpreedlyExpress.onPaymentMethod(function (token, paymentMethod) {
					vm.$loading({fullscreen: true});
					// Send requisite payment method info to backend
					var tokenField = document.getElementById("payment_method_token");

					tokenField.setAttribute("value", token);
					
					var masterForm = document.getElementById('payment-form');
					
					
					masterForm.submit();
				});
			}
	    },
	    
        mounted() {
            let vm = this;
            window.kinfEvents.$emit('EditProfile:sendFundraiser', this.fundraiser);
            window.kinfEvents.$emit('FundraiserUpdates:authenticated', this.authenticated);
            window.kinfEvents.$emit('FundraiserUpdates:sendUserInfo', this.user);
            window.kinfEvents.$emit('FundraiserUpdates:sendFundraiser', this.fundraiser);
            window.kinfEvents.$emit('FundraiserUpdates:notifyUpdate', this.post);
            window.kinfEvents.$emit('LoginButton:authenticated', this.authenticated);
        },
        
	    created() {

            let vm = this;
            if (this.postData !== undefined) {
                this.post = JSON.parse(JSON.stringify(this.postData));
            }

            $(document).ready(() => {

	            // make sure spreedly loads
	            if(window.SpreedlyExpress === undefined){
					//window.Spreedly
					console.log(window.SpreedlyExpress);
					return this.loadSpreedlyApi();
	            }
	            
	            
	            
	            if(this.useReponsiveTab){
					jQuery('.tab-section').easyResponsiveTabs({
						type: 'default', //Types: default, vertical, accordion
						width: 'auto', //auto or any width like 600px
						fit: true,   // 100% fit in a container
						closed: 'accordion', // Start closed if in accordion view
						//disabled:[0],
						activate: function (event) { // Callback function if tab is switched
							var $tab = $(this);
							var $info = $('#tabInfo');
							var $name = $('span', $info);
							$name.text($tab.text());
							$info.show();
							
							if ($tab[0].innerHTML == 'Story') {
								window.history.pushState(null, '', vm.$parent.appData.globalData.routes.fundraiser_show + '/' + vm.fundraiser.slug);
								vm.post = undefined;
								vm.currentTab = 'story'
							} else {
								vm.currentTab = 'updates';
								kinfEvents.$emit('FundraiserUpdate:tabUpdateOpen');
								// window.history.pushState(null, '', vm.$parent.appData.globalData.routes.fundraiser_show + '/' + vm.fundraiser.slug + '/updates');
								// vm.post = 'hola mundo';
							}
							
						}
					});
				}
                
                setTimeout(() => {
                    if (vm.post !== undefined) {
                        document.getElementsByClassName('resp-tab-item')[1].click()
                        this.currentTab = 'updates';
                    } else {
                        this.currentTab = 'story';
                    }
                }, 10);

                SpreedlyExpress.init(window.App.spreedlyKey, {
                    "amount": "$0.00",
                    "company_name": window.App.spreedlyCompanyName,
                    "sidebar_top_description": window.App.spreedlyCompanyDescription,
                    "sidebar_bottom_description": "Project: <br> " + this.fundraiser.title,
                    "full_name": "",
                }, {
                    "email": ""
                });
				
                this.registerSpreedlyExpressPyamentListener();
            });


        }

    }
</script>

<style scoped>
	.resp-tab-disabled{
		color:#d2d2d2 !important;
        cursor: not-allowed;
	}
	.mt-20{
		margin-top:40px;
	}
</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/PageShowFundraiser.vue